import { IndentContext, indentString } from "@codemirror/language";

export const createListItem = (state, pos) => {
    const context = new IndentContext(state);
    const columns = context.lineIndent(pos);
    const indent = indentString(state, columns);
    return `${indent}\\item `;
};
